module.exports = __webpack_public_path__ + "media/inserate/assets/images/large-60002028450bac1c3b23b57ae707ffc5.png";